import { render, staticRenderFns } from "./BoxStatus.vue?vue&type=template&id=22bb501e&scoped=true"
import script from "./BoxStatus.vue?vue&type=script&lang=ts"
export * from "./BoxStatus.vue?vue&type=script&lang=ts"
import style0 from "./BoxStatus.vue?vue&type=style&index=0&id=22bb501e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb501e",
  null
  
)

export default component.exports